// import gql from 'graphql-tag'
import { gql } from '../../../../../hooks/useQuery'

export const DELETE_ANOMALY_TYPES = gql`
  mutation AdministrationDeleteAnalysisAnomalyTypes($id: ID!) {
    aDelete(path: "analysis/anomaly/types", id: $id) {
    }
  }
`

export const LIST_ANOMALY_TYPES = gql`
  query AdministrationListAnalysisAnomalyTypes(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "analysis/anomaly/types"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
